export const initialState = {
  Notification: {
    open: false,
    message: "",
    severity: "string",
  },
  searchString: {
    menu1: "",
    menu2: "",
    menu3: "",
    menu4: "",
    menu5: "",
    menu6: "",
  },
  trackingData: {
    serviceStatus: 0,
    captcha: "",
  },
};
